import { gql } from '@apollo/client'
import React from 'react'

import { segmentsClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useSegmentState = () => React.useContext(Context)
export const useSegment = () => useSegmentState()?.segment

const QUERY = gql`
  query Segment($id: ID) {
    segment(id: $id, filter: { includeDeleted: true }) {
      id
      name
      insertedAt
      updatedAt
      deleted
      placeLevels {
        id
        name
        type
      }
      userGroups {
        id
        name
      }
      checklistTypes {
        id
        name
      }
      assets {
        id
        name
      }
    }
  }
`

const SegmentsLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: segmentsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default SegmentsLoader
